import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Tabs,
  Tab,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { serviceConsumer } from "../../../network/ServiceConsumer";

const RoundMedalsModal = ({
  open,
  onClose,
  rounds,
  competitionId,
  handleRoundMedal,
}) => {
  const [judge, setJudge] = useState("");
  const [round, setRound] = useState("");
  const [places, setPlaces] = useState(""); // will store "custom", "3", "5", "40%", "50%" etc
  const [customType, setCustomType] = useState("top"); // top | percentage
  const [customValue, setCustomValue] = useState(""); // numeric input
  const [judgesList, setJudgesList] = useState([]);

  const handleContinue = () => {
    const selectedJudge = judgesList?.find((item) => item._id === judge)?.name;

    let finalPlaces = "";
    let type = "";

    if (places === "custom") {
      // custom input case
      finalPlaces = customValue;
      type = customType;
    } else {
      // static options case
      if (places.includes("%")) {
        finalPlaces = places.replace("%", ""); // remove %
        type = "percentage";
      } else {
        finalPlaces = places;
        type = "top";
      }
    }

    handleRoundMedal({
      judge,
      round,
      places: finalPlaces, // always a clean number (no %)
      type,
      selectedJudge,
    });
  };

  useEffect(() => {
    const getJudgeList = async () => {
      try {
        const resultsUrl = `${process.env.REACT_APP_BASE_URL}/feis/competition/details/${competitionId}`;
        const resultsResponse = await serviceConsumer("GET", resultsUrl);
        setJudgesList(resultsResponse.competition);
      } catch (err) {
        console.log(err);
      }
    };
    if (competitionId) {
      getJudgeList();
    }
  }, [competitionId]);

  const isDisabled =
    !judge ||
    !round ||
    !places ||
    (places === "custom" && (!customValue || Number(customValue) <= 0));

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          bgcolor: "white",
          p: 4,
          borderRadius: 2,
          width: 400,
          position: "relative",
          boxShadow: 24,
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>

        {/* Title */}
        <Typography variant="h6" align="center" mb={3} fontWeight={400}>
          Round Medals
        </Typography>

        {/* Judge */}
        <div style={{ marginBottom: "16px" }}>
          <Typography sx={{ fontWeight: 500, mb: 0.5, fontSize: "12px" }}>
            Select Judge:
          </Typography>
          <select
            className="check-in-select"
            value={judge}
            onChange={(e) => setJudge(e.target.value)}
            style={{ width: "335px" }}
          >
            <option value="" key={0}>
              Select
            </option>
            {judgesList?.map((item) => (
              <option key={item?._id} value={item?._id}>
                {item?.name}
              </option>
            ))}
          </select>
        </div>

        {/* Round */}
        <div style={{ marginBottom: "16px" }}>
          <Typography sx={{ fontWeight: 500, mb: 0.5, fontSize: "12px" }}>
            Select Round:
          </Typography>
          <select
            className="check-in-select"
            style={{ width: "335px" }}
            value={round}
            onChange={(e) => setRound(e.target.value)}
          >
            <option value="" key={0}>
              Select
            </option>
            {Array.from({ length: rounds }, (_, i) => i + 1).map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        {/* Places */}
        <div style={{ marginBottom: "16px" }}>
          <Typography sx={{ fontWeight: 500, mb: 0.5, fontSize: "12px" }}>
            How many Places:
          </Typography>
          <select
            className="check-in-select"
            style={{ width: "335px", padding: "6px" }}
            value={places}
            onChange={(e) => setPlaces(e.target.value)}
          >
            <option value="" key={0}>
              Select
            </option>

            {/* Top options */}
            <option value="3">Top 3</option>
            <option value="5">Top 5</option>

            {/* Divider */}
            <option
              disabled
              style={{ borderTop: "1px solid #ccc", margin: "4px 0" }}
            >
              ―――――――――――――――――
            </option>

            {/* Percentage options */}
            <option value="40%">Top 40%</option>
            <option value="50%">Top 50%</option>

            {/* Divider */}
            <option
              disabled
              style={{ borderTop: "1px solid #ccc", margin: "4px 0" }}
            >
              ―――――――――――――――――
            </option>

            {/* Custom at bottom */}
            <option value="custom">Custom</option>
          </select>
        </div>

        {/* Custom Options */}
        {places === "custom" && (
          <div style={{ marginBottom: "16px" }}>
            <Tabs
              value={customType}
              onChange={(e, val) => setCustomType(val)}
              sx={{ mb: 2 }}
            >
              <Tab label="Number of Places" value="top" />
              <Tab label="Percentage to Place" value="percentage" />
            </Tabs>
            <TextField
              type="number"
              label={"Enter here"}
              value={customValue}
              onChange={(e) => setCustomValue(e.target.value)}
              fullWidth
            />
          </div>
        )}

        {/* Continue Button */}
        <Box mt={4} textAlign="center">
          <button
            className={isDisabled ? "disabled" : "filled"}
            onClick={handleContinue}
            disabled={isDisabled}
          >
            Continue
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RoundMedalsModal;
